import { registerPlugin } from "@capacitor/core";
import { isAndroidPlatform } from "./microphone";

const MediaPermissions = registerPlugin("MicrophonePermissions");

const isGranted = result => result?.state === "granted";

export async function requestVideoCallPermissions() {
  if (!isAndroidPlatform) return { microphone: "browser", camera: "browser" };

  const microphone = await MediaPermissions.request();
  if (!isGranted(microphone)) {
    const error = new Error("L’accès au microphone a été refusé.");
    error.code = "microphone-denied";
    throw error;
  }

  const camera = await MediaPermissions.requestCamera();
  if (!isGranted(camera)) {
    const error = new Error("L’accès à la caméra a été refusé.");
    error.code = "camera-denied";
    throw error;
  }

  return { microphone: microphone.state, camera: camera.state };
}

export async function openVideoCallSettings() {
  if (isAndroidPlatform) await MediaPermissions.openSettings();
}

export function dailyMediaErrorMessage(error) {
  const text = String(error?.errorMsg || error?.message || error?.type || "").toLowerCase();
  if (text.includes("permission") || text.includes("notallowed")) {
    return "L’accès à la caméra ou au microphone a été refusé.";
  }
  if (text.includes("notfound") || text.includes("device not found")) {
    return "Aucune caméra ou aucun microphone compatible n’a été détecté.";
  }
  if (text.includes("notreadable") || text.includes("trackstart") || text.includes("in use")) {
    return "La caméra ou le microphone est déjà utilisé par une autre application.";
  }
  if (text.includes("network") || text.includes("connection")) {
    return "La connexion à l’appel a été interrompue.";
  }
  return "Impossible d’accéder à la caméra ou au microphone.";
}
